"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingSpinner = void 0;
var _react = require("@emotion/react");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const spin = (0, _react.keyframes)`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const Spinner = (0, _mui.styled)(_icons.OriflameSpinner)(({
  theme
}) => ({
  animation: `${spin} 1s linear infinite`,
  color: theme.palette.common.white,
  zIndex: 2
}));
const LoadingSpinner = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(Spinner, {});
exports.LoadingSpinner = LoadingSpinner;